import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  FORM_API_BASE_URL = SERVER_API_URL + 'forms/filterInputData';

  private mobileFilterIsOpenSubject = new BehaviorSubject<boolean>(false);
  mobileFilterIsOpen$ = this.mobileFilterIsOpenSubject.asObservable();

  private renderer: Renderer2;

  constructor(
    private http: HttpClient,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  get mobileFilterIsOpen(): boolean {
    return this.mobileFilterIsOpenSubject.value;
  }

  openMobileFilterOnClick(): void {
    this.mobileFilterIsOpenSubject.next(true);
    this.renderer.addClass(document.body, 'no-scroll');
  }

  closeMobileFilterOnClick(): void {
    this.mobileFilterIsOpenSubject.next(false);
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  getFilterData(): Observable<any> {
    return this.http.get<any>(this.FORM_API_BASE_URL);
  }

  buildRouterUrl(category: string, country: string, bandGroup: string, band: string): string {
    if (category === 'reports') {
      return '/reports/upcoming';
    }

    if (country && band) {
      return `/${category}/country/${country}/band/${band}`;
    }

    if (country && bandGroup) {
      return `/${category}/country/${country}/bandGroup/${bandGroup}`;
    }

    if (country) {
      return `/${category}/country/${country}`;
    }

    if (band) {
      return `/${category}/band/${band}`;
    }

    if (bandGroup) {
      return `/${category}/bandGroup/${bandGroup}`;
    }

    return `/${category}`;
  }
}